import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbsService } from '@bci-web-core/core';
import { Subscription } from 'rxjs';

export let browserRefresh = false;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
  private subscription: Subscription;

  constructor(
    private breadcrumbsService: BreadcrumbsService,
    private router: Router
  ) {}

  ngOnInit() {
    const t = this;
    setTimeout(function () {
      t.breadcrumbsService.setTitle('home', 'RBEI , BOSCHJAIPUR , JAIPUR');
    }, 200);
  }
  ngAfterViewInit() {}
}
